import React from 'react'

import { ArticleCard } from '@/shared/components/ArticleCard/ArticleCard'
import { pxToRem } from '@/shared/styles/themes'
import { Article } from '@/slices/blog/mocks/articles'
import { Box, Grid, styled, Typography } from '@mui/material'

interface RelatedArticlesProps {
  articles: Article[]
}

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ articles }) => {
  if (articles.length === 0) {
    return null
  }

  return (
    <RelatedSection>
      <SectionDivider>
        <DividerLine />
        <DividerLabel>Keep Reading</DividerLabel>
        <DividerLine />
      </SectionDivider>

      <Grid container spacing={4}>
        {articles.map((article) => (
          <Grid item xs={12} sm={6} md={4} key={article.id}>
            <ArticleCard article={article} />
          </Grid>
        ))}
      </Grid>
    </RelatedSection>
  )
}

const RelatedSection = styled(Box)(({ theme }) => ({
  marginTop: pxToRem(40),
  marginBottom: pxToRem(20),

  [theme.breakpoints.up('md')]: {
    marginTop: pxToRem(56),
  },
}))

const SectionDivider = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: pxToRem(16),
  marginBottom: pxToRem(32),

  [theme.breakpoints.up('md')]: {
    marginBottom: pxToRem(40),
  },
}))

const DividerLine = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 1,
  backgroundColor: theme.palette.divider,
}))

const DividerLabel = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(13),
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: theme.palette.text.disabled,
  flexShrink: 0,
}))
